import React, { useEffect } from 'react';
import {
  FormControl,
  FormLabel,
  GridItem,
  Switch,
  Grid,
} from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';
import Select from 'react-select';
import { useNewKBLeadForm } from '../context/NewKBLeadFormContext';

const NewKBPreferencesForm = () => {
  // Use the form context for state management
  const { 
    formData, 
    handleFormChange,
    metadata,
    errors
  } = useNewKBLeadForm();

  // Get entertainment options from metadata
  const entertainmentOptions = metadata?.entertainmentOptions || [];
  
  // Log initial values for debugging
  useEffect(() => {
    console.log('[NewKBPreferencesForm] Initial Preferences Form Values:', { 
      foodPreference: formData.foodPreference,
      alcoholPreference: formData.alcoholPreference,
      entertainmentOptions: formData.entertainmentOptions,
      isCold: formData.isCold,
      availableOptions: entertainmentOptions
    });
  }, []);
  
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={6}>
      <GridItem>
        <FormControl isInvalid={errors?.foodPreference}>
          <FormLabel>Food Preference</FormLabel>
          <ChakraSelect
            value={formData.foodPreference || ''}
            onChange={(e) => {
              console.log('[NewKBPreferencesForm] Food Preference changed:', e.target.value);
              handleFormChange('foodPreference', e.target.value);
            }}
          >
            <option value="">Select Food Preference</option>
            <option value="veg">Vegetarian</option>
            <option value="non-veg">Non-Vegetarian</option>
          </ChakraSelect>
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl isInvalid={errors?.alcoholPreference}>
          <FormLabel>Alcohol Preference</FormLabel>
          <ChakraSelect
            value={formData.alcoholPreference || ''}
            onChange={(e) => {
              console.log('[NewKBPreferencesForm] Alcohol Preference changed:', e.target.value);
              handleFormChange('alcoholPreference', e.target.value);
            }}
          >
            <option value="">Select Alcohol Preference</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </ChakraSelect>
        </FormControl>
      </GridItem>

      <GridItem colSpan={2}>
        <FormControl isInvalid={errors?.entertainmentOptions}>
          <FormLabel>Entertainment Options</FormLabel>
          <Select
            isMulti
            value={(formData.entertainmentOptions || []).map(optId => {
              const option = entertainmentOptions.find(o => o._id === optId);
              return option ? { label: option.name, value: option._id } : null;
            }).filter(Boolean)}
            onChange={(selected) => {
              console.log('[NewKBPreferencesForm] Entertainment Options changed:', selected);
              const options = selected ? selected.map(option => option.value) : [];
              handleFormChange('entertainmentOptions', options);
            }}
            options={entertainmentOptions.map(opt => ({
              label: opt.name,
              value: opt._id
            }))}
            placeholder="Select entertainment options"
          />
        </FormControl>
      </GridItem>

      <GridItem>
        <FormControl display="flex" alignItems="center" isInvalid={errors?.isCold}>
          <FormLabel mb="0">Is Cold Lead?</FormLabel>
          <Switch
            isChecked={formData.isCold || false}
            onChange={(e) => {
              console.log('[NewKBPreferencesForm] Cold Lead toggle:', e.target.checked);
              handleFormChange('isCold', e.target.checked);
            }}
          />
        </FormControl>
      </GridItem>
    </Grid>
  );
};

export default NewKBPreferencesForm;
